// import Box from "@mui/material/Box";
// import CircularProgress from "@mui/material/CircularProgress";
// import CloseIcon from "@mui/icons-material/Close";
// import TableTopicsData from "../../../Pages/IndividualUnit/TableTopicsData";
// import TopicDetailsModal from "./TopicsDetailModal";
// import WeekSelector from "./WeekSelector";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import { Card, CardBody, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";


// import StudentIssueTable from "./StudentIssueTable";

// import React, {
//   useEffect,
//   forwardRef,
//   useImperativeHandle,
//   useState,
// } from 'react';

// const TopicDiscussedTab = ({ fullURL, payload, resetTrigger, summarystudent, isApiLoading , urlWeek }) => {
//   const [selectedWeeks, setSelectedWeek] = useState(null);
//   const [tableDisplayData, setTableDisplayData] = useState([]); // This will hold data for the table
//   const [fullTopicData, setFullTopicData] = useState({}); // This will hold the raw data from API, including Q&A
//   const [weeks, setWeeks] = useState({});

//   const location = useLocation();
// const subTab = new URLSearchParams(location.search).get("subTab");
// const [activeSubtab, setActiveSubtab] = useState(subTab ? subTab : "Topics Covered");



//   const [loading, setloading] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [modalContent, setModalContent] = useState([]);
//   const [modalTitle, setModalTitle] = useState('');
//   const [weekPeriod, setweekPeriod] = useState(null);
//   const [tableissuesDisplayData, settableissuesDisplayData] = useState([]); // This will hold data for the table
//   const user_token = localStorage.getItem('usertoken');

//   const [studentIssueSummary, setStudentIssueSummary] = useState({});
// const [studentIssueProactive, setStudentIssueProactive] = useState([]);
// const [summaryAllTopics, setSummaryTopics] = useState("");
// const didMountRef = useRef(false);


//   console.log("Inside Teacher Insght for Student issue")
//   const toggleSubTab = (tab) => {
//     setActiveSubtab(tab);
//   };
//   // useEffect(() => {
//   //   // Reset weeks state when resetTrigger changes
//   //   setOpenModal(false);
//   //   setWeeks({});
//   //   setSelectedWeek(null);
//   //   setweekPeriod(null);
//   //   setTableDisplayData([]);
//   //   settableissuesDisplayData([]);
//   //   setloading(false);
//   // }, [resetTrigger]);


//   useEffect(() => {
//   setOpenModal(false);
//   setWeeks({});
//   setSelectedWeek(null);
//   setweekPeriod(null);
//   setTableDisplayData([]);
//   settableissuesDisplayData({});
//   setStudentIssueSummary({});
//   setStudentIssueProactive([]);
//   setSummaryTopics("");
//   setloading(false);

//   if (didMountRef.current) {
//     setActiveSubtab("Topics Covered");
//   } else {
//     didMountRef.current = true;
//   }
// }, [resetTrigger]);

 
// const fetchTableData = async () => {
//     setweekPeriod(null);
//     setloading(true);
//     if (!payload || Object.keys(payload).length === 0) return;

//     let config = {
//         headers: {
//             Authorization: `Token ${user_token}`,
//         },
//     };

//     try {
//         const tableres = await axios.post(fullURL, {
//             ...payload,
//             mode: 'insights',
//             week: selectedWeeks.label,
//         }, config);

//         console.warn({ tableres });

//         // ✅ Updated: tableres.data.issues (axios wraps response in .data)
//         settableissuesDisplayData(tableres?.issues || {});

//         if (tableres) {
//             setFullTopicData(tableres?.topics || {});


//             settableissuesDisplayData(tableres?.issues || {});
//             setStudentIssueSummary(tableres?.student_issues_summary || {});
//             setStudentIssueProactive(tableres?.student_issues_proactive || []);
//             setSummaryTopics(tableres?.summary || "");

//             setweekPeriod(tableres?.week || null);

//             const transformedData = Object.keys(tableres?.topics || {}).map(
//                 (topicName, index) => {
//                     const questions = tableres.topics[topicName].clusters;
//                     const questionsCount = questions.length;

//                     return {
//                         id: index + 1,
//                         topicName: topicName,
//                         Noofstudentsasked: tableres.topics[topicName].total_students,
//                         Noofquestionsasked: questionsCount,
//                     };
//                 }
//             );

//             const sortedData = transformedData.sort(
//                 (a, b) => b.Noofstudentsasked - a.Noofstudentsasked
//             );

//             setTableDisplayData(sortedData);
//         }
//     } catch (error) {
//         console.error('Error fetching table data:', error);
//         setTableDisplayData([]);
//         setFullTopicData({});
//         settableissuesDisplayData({});
//     } finally {
//         setloading(false);
//     }
// };

// useEffect(() => {
//   if (!urlWeek) return;
//   const weekNumber = Number(urlWeek);
//   if (isNaN(weekNumber)) return;
//   setSelectedWeek({ label: `Week #${weekNumber}`, value: weekNumber });
// }, [urlWeek]);

//   // useEffect(() => {
//   //   if (!selectedWeeks) {
//   //     setTableDisplayData([]);
//   //     setweekPeriod(null);
//   //     settableissuesDisplayData([]);

//   //   }
//   // }, [selectedWeeks]);


//   useEffect(() => {
//   if (!selectedWeeks && !urlWeek) {
//     setTableDisplayData([]);
//     setweekPeriod(null);
//     settableissuesDisplayData({});
//     setStudentIssueSummary({});
//     setStudentIssueProactive([]);
//     setSummaryTopics("");
//     setloading(false);
//   }
// }, [selectedWeeks, urlWeek]);


//   useEffect(() => {
//     setWeeks({});
//   }, [fullURL]);

//   useEffect(() => {
//     console.warn('selectedWeeks', selectedWeeks);
//     if (selectedWeeks) {
//       fetchTableData();
//     }
//   }, [selectedWeeks, payload]);

//   useEffect(() => {
//     console.warn('payload', payload);
//     if (!payload || Object.keys(payload).length === 0) return;
//     let config = {
//       headers: {
//         Authorization: `Token ${user_token}`,
//       },
//     };
//     const fetchWeeks = async () => {
//       try {
//         const weekres = await axios.post(fullURL, {
//           ...payload,
//           mode: 'insights',
//         }, config);
//         if (weekres && weekres && weekres.weeks) {
//           setWeeks(weekres.weeks);
//         }
//       } catch (error) {
//         console.error('Error fetching weeks:', error);
//       }
//     };

//     fetchWeeks();
//   }, [fullURL, payload]);

//   const handleTopicClick = (topicName) => {
//     const topicDetails = fullTopicData[topicName];
//     setModalContent(topicDetails);
//     setModalTitle(topicName);
//     setOpenModal(true);
//     // }
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setModalContent([]);
//     setModalTitle('');
//   };

//   return (
//     <div style={{ minHeight: '200px' }}>
//       <div className="d-flex align-items-center">
//         <div>
//           {weekPeriod && (
//             <p className="mb-2">
//               Week Period :
//               <strong className="ml-1" style={{ marginLeft: '5px' }}>
//                 {weekPeriod ? weekPeriod : 'N/A'}
//               </strong>
//             </p>
//           )}
//         </div>
//         <div className="ms-auto">
//           <WeekSelector
//             weeks={weeks}
//             selectedWeeks={selectedWeeks}
//             setSelectedWeek={setSelectedWeek}
//           />
//         </div>
//       </div>


//       {isApiLoading || loading ?  ( // Show spinner only when API is loading
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{ height: '200px' }}
//         >
//           <Spinner style={{ width: '3rem', height: '3rem' }} />
//         </div>
//       ) : (
//         // Data loaded state
//         <>
//           {/* Conditional rendering for TableTopicsData based on tableDisplayData */}
//           {selectedWeeks ? (
//             <>
//               <Nav tabs>
//                 <NavItem>
//                   <NavLink
//                     className={
//                       activeSubtab === 'Topics Covered' ? 'active' : ''
//                     }
//                     active={activeSubtab === 'Topics Covered'}
//                     onClick={() => toggleSubTab('Topics Covered')}
//                     style={{
//                       cursor: 'pointer',
//                       marginRight: '3px',
//                     }}
//                   >
//                     Topics Covered
//                   </NavLink>
//                 </NavItem>
//                 <NavItem>
//                   <NavLink
//                     className={
//                       activeSubtab === 'Student Issues' ? 'active' : ''
//                     }
//                     active={activeSubtab === 'Student Issues'}
//                     onClick={() => toggleSubTab('Student Issues')}
//                     style={{
//                       cursor: 'pointer',
//                       marginRight: '3px',
//                     }}
//                   >
//                     Student Issues
//                   </NavLink>
//                 </NavItem>
//               </Nav>

//               {activeSubtab === 'Topics Covered' && (
//                 <>
//                   <TableTopicsData
//                     noRowsLabel={'No Call Insights Available for this Week'}
//                     topicsData={tableDisplayData}
//                     onTopicClick={handleTopicClick}
//                     columns={[
//                       {
//                         field: 'sno',
//                         headerName: 'S.No',

//                         width: 80,
//                         headerAlign: 'left',
//                         align: 'center',
//                         sortable: false,
//                         // Just show sno value, no renderCell needed
//                       },
//                       {
//                         field: 'topicName',
//                         headerName: 'Topics',
//                         flex: 1,
//                         minWidth: 200,
//                       },
//                       {
//                         field: 'Noofstudentsasked',
//                         headerName: 'No of Students Asked',
//                         width: 230,
//                         headerAlign: 'left',
//                         align: 'center',
//                       },
//                       {
//                         field: 'Noofquestionsasked',
//                         headerName: 'No of Questions Asked',
//                         width: 230,
//                         headerAlign: 'left',
//                         align: 'center',
//                       },
//                     ]}
//                   />
//                 </>
//               )}
//              {/* {activeSubtab === 'Student Issues' && (
//                 <div className="row mt-2">
//                   <div className="col-md-12 ">
//                     {
//                       Object.keys(tableissuesDisplayData || {}).length > 0 ?
//                     Object.keys(tableissuesDisplayData).map((topic, index) => (
//                       <div key={index} className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light">
//                         <h6 className="fw-bold  mb-2">{topic}</h6>
//                         <ul className="list-group-item-info ps-3">
//                           {tableissuesDisplayData[topic].map((issue, issueIndex) => (
//                             <li key={issueIndex} className="mb-1 text-dark">
//                               <i className="bi bi-dot me-2 text-secondary"></i>{issue}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     )): <p className="ms-3">No Student Issues Available</p>}
//                   </div>
//                 </div>
//               )} */}
//               {activeSubtab === 'Student Issues' && (
//     <div className="row mt-2">
//         <div className="col-md-12">
//             {tableissuesDisplayData && Object.keys(tableissuesDisplayData).length > 0 ? (
//                 Object.keys(tableissuesDisplayData).map((category, categoryIndex) => {
//                     const categoryData = tableissuesDisplayData[category];
//                     const formatTitle = (str) =>
//                         str.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

//                     return (
//                         <div key={categoryIndex} className="mb-3">
//                             {/* Category Title */}
//                             <h4 className="fw-bold mb-2">{formatTitle(category)}</h4>

//                             <h4 className="fw-bold mb-1">Students Flagged Based on 1:1 Session Engagement</h4>
// <p className="text-muted mb-3 mt-0 pt-0">
//   This list is generated based on students who have had at least one 1:1
//   consultation session with their facilitator during the previous week.
// </p>
// <StudentIssueTable StudentList={studentIssueProactive} />

//                             {/* Topics inside this category */}
//                             {Object.keys(categoryData).map((topic, topicIndex) => (
//                                 <div
//                                     key={topicIndex}
//                                     className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light"
//                                 >
//                                     {/* Topic Title */}
//                                     <h6 className="fw-bold mb-2">{topic}</h6>

//                                     {/* Issues list */}
//                                     <ul className="ps-3">
//                                         {categoryData[topic].map((issue, issueIndex) => (
//                                             <li key={issueIndex} className="mb-1 text-dark">
//                                                 {issue}
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             ))}
//                         </div>
//                     );
//                 })
//             ) : (
//                 <p className="ms-3">No Student Issues Available</p>
//             )}
//         </div>
//     </div>
//                 )}
//             </>
//           ) : (
//             <div class="col-12">
//               <p class="text-muted w-100 mt-3 text-center">
//                 <>Please Select the week to view Call Insights</>
//               </p>
//             </div>
//           )}

//           {/* TopicDetailsModal always rendered but its 'open' prop controls visibility */}
//           <TopicDetailsModal
//             open={openModal}
//             onClose={handleCloseModal}
//             title={modalTitle}
//             contentDetails={modalContent.clusters}
//           />
//         </>
//       )}
//     </div>
//   );
// };

// export default TopicDiscussedTab;




import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Nav, NavItem, NavLink, Spinner } from "reactstrap";

import TableTopicsData from "../../../Pages/IndividualUnit/TableTopicsData";
import TopicDetailsModal from "./TopicsDetailModal";
import WeekSelector from "./WeekSelector";
import StudentIssueTable from "./StudentIssueTable";

const TopicDiscussedTab = ({
  fullURL,
  payload,
  resetTrigger,
  summarystudent,
//   isApiLoading,
// }) => {

  isApiLoading,
  urlWeek,
  initialSubTab,


  onStudentClick,

}) => {
  const user_token = localStorage.getItem("usertoken");

  // Read ?subTab= from the URL (mail link opens "Student Issues" directly)
  const location = useLocation();
  const subTab = new URLSearchParams(location.search).get("subTab");

  // ---------- state ----------
  const [selectedWeeks, setSelectedWeek] = useState(null);
  const [weeks, setWeeks] = useState({});
  const [weekPeriod, setweekPeriod] = useState(null);
  const [loading, setloading] = useState(false);
  // const [activeSubtab, setActiveSubtab] = useState(subTab ? subTab : "Topics Covered");
  const [activeSubtab, setActiveSubtab] = useState(initialSubTab || subTab || "Topics Covered");
  // topics
  const [tableDisplayData, setTableDisplayData] = useState([]);
  const [fullTopicData, setFullTopicData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  // student issues
  const [tableissuesDisplayData, settableissuesDisplayData] = useState({});
  const [studentIssueSummary, setStudentIssueSummary] = useState({});
  const [studentIssueProactive, setStudentIssueProactive] = useState([]);
  const [summaryAllTopics, setSummaryTopics] = useState("");

  // Skip the "reset to Topics Covered" on first mount so ?subTab= survives
  const didMountRef = useRef(false);

  const toggleSubTab = (tab) => setActiveSubtab(tab);

  // ---------- reset when unit / filters change ----------
  useEffect(() => {
    setOpenModal(false);
    setWeeks({});
    setSelectedWeek(null);
    setweekPeriod(null);
    setTableDisplayData([]);
    settableissuesDisplayData({});
    setStudentIssueSummary({});
    setStudentIssueProactive([]);
    setSummaryTopics("");
    setloading(false);

    if (didMountRef.current) {
      setActiveSubtab("Topics Covered");
    } else {
      didMountRef.current = true;
    }
  }, [resetTrigger]);

  // Clear data when no week is selected
  useEffect(() => {
    if (!selectedWeeks) {
      setTableDisplayData([]);
      setweekPeriod(null);
      settableissuesDisplayData({});
      setStudentIssueProactive([]);
      setSummaryTopics("");
      setloading(false);
    }
  }, [selectedWeeks]);

  useEffect(() => {
    setWeeks({});
  }, [fullURL]);


 useEffect(() => {
   if (!urlWeek) return;
   if (!weeks || Object.keys(weeks).length === 0) return; 

  console.log("urlWeek",urlWeek)
   const parseDDMMYYYY = (str) => {
     const [dd, mm, yy] = String(str).split("-").map(Number);
     if (!dd || !mm || !yy) return NaN;
     const yyyy = yy < 100 ? 2000 + yy : yy; 
     return new Date(yyyy, mm - 1, dd).getTime();
   };
 
   const parseYYYYMMDD = (str) => {
     const [yyyy, mm, dd] = String(str).split("-").map(Number);
     if (!dd || !mm || !yyyy) return NaN;
     return new Date(yyyy, mm - 1, dd).getTime();
   };
 
   const targetTime = parseDDMMYYYY(urlWeek);
   if (isNaN(targetTime)) return;
 
   const sortedWeeks = Object.entries(weeks)
     .map(([label, value]) => ({ label, value, time: parseYYYYMMDD(value) }))
     .filter((w) => !isNaN(w.time))
     .sort((a, b) => a.time - b.time);
 
   const matched = sortedWeeks.find((week, index) => {
     const nextWeek = sortedWeeks[index + 1];
     const weekEnd = nextWeek ? nextWeek.time : Infinity; // last week has no upper bound
     return targetTime >= week.time && targetTime < weekEnd;
   });
 
   if (matched) {
     setSelectedWeek({ label: matched.label, value: matched.value });
   } else {
     console.warn("[TopicDiscussedTab] no week found matching urlWeek:", urlWeek, weeks);
   }
 }, [urlWeek, weeks]);

  // ---------- API: table / insights data ----------
  const fetchTableData = async () => {
    if (!payload || Object.keys(payload).length === 0) return;

    setweekPeriod(null);
    setloading(true);

    const config = { headers: { Authorization: `Token ${user_token}` } };

    try {
      const tableres = await axios.post(
        fullURL,
        { ...payload, mode: "insights", week: selectedWeeks?.label },
        config
      );

      settableissuesDisplayData(tableres?.issues || {});
      setStudentIssueSummary(tableres?.student_issues_summary || {});
      setStudentIssueProactive(tableres?.student_issues_proactive || []);
      // setSummaryTopics(tableres?.summary || "");

      if (tableres) {
        setFullTopicData(tableres?.topics || {});
        setweekPeriod(tableres?.week || null);

        const transformedData = Object.keys(tableres?.topics || {}).map(
          (topicName, index) => {
            const questions = tableres.topics[topicName].clusters;
            return {
              id: index + 1,
              topicName,
              Noofstudentsasked: tableres.topics[topicName].total_students,
              Noofquestionsasked: questions.length,
            };
          }
        );

        
        setTableDisplayData(
          transformedData.sort((a, b) => b.Noofstudentsasked - a.Noofstudentsasked)
        );
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
      setTableDisplayData([]);
      setFullTopicData({});
      settableissuesDisplayData({});
      setStudentIssueProactive([]);
      setSummaryTopics("");
    } finally {
      setloading(false);
    }
  };

  // ONE effect only (two of these would call the API twice)
  useEffect(() => {
    if (!selectedWeeks) return;
    if (!payload || Object.keys(payload).length === 0) return;
    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWeeks, payload]);

  // ---------- API: available weeks ----------
  useEffect(() => {
    if (!payload || Object.keys(payload).length === 0) return;

    const config = { headers: { Authorization: `Token ${user_token}` } };

    const fetchWeeks = async () => {
      try {
        const weekres = await axios.post(fullURL, { ...payload, mode: "insights" }, config);
        if (weekres && weekres.weeks) {
          setWeeks(weekres.weeks);
        }
      } catch (error) {
        console.error("Error fetching weeks:", error);
      }
    };

    fetchWeeks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullURL, payload]);

  // ---------- modal ----------
  const handleTopicClick = (topicName) => {
    setModalContent(fullTopicData[topicName]);
    setModalTitle(topicName);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent([]);
    setModalTitle("");
  };

  // ---------- render ----------
  return (
    <div>
      {/* ================= FIRST CARD ================= */}
      <Card className="mb-2">
        <CardBody>
          {/* Header */}
          <div className="d-flex align-items-center mb-3">
            <div>
              {weekPeriod && (
                <div>

                <p className="mb-2">
                  Week Period :<strong className="ms-1">{weekPeriod}</strong>
                </p>
<br></br>
                <div style={{
                    fontStyle: "italic",
                    color: "#888",
                    fontWeight: 400,
                    marginBottom:"3px"
                  }} >This voice analysis tool generates insights and recommendations based on the data and details provided. While the suggestions aim to support session performance improvement, they may not be applicable to every situation or context. Recommendations that do not align with the intended teaching objectives or specific academic requirements may be disregarded, with decisions guided by professional expertise and academic judgment.</div>
                  {/* <br></br> */}
                </div>
                // <div style={{
                //     fontStyle: "italic",
                //     color: "#888",
                //     fontWeight: 400,
                //     marginBottom:"3px"
                //   }} >This voice analysis tool generates insights and recommendations based on the data and details provided. While the suggestions aim to offer the best possible guidance for enhancing your session's performance, they may not apply to every situation or context. If you find any advice irrelevant or non-applicable to your specific teaching goals, feel free to disregard it and proceed with the best course of action based on your professional and academic judgment.</div>
                //   {/* <br></br> */}
                // </div>
                
              )}
            </div>
            <div className="ms-auto">
              <WeekSelector
                weeks={weeks}
                selectedWeeks={selectedWeeks}
                setSelectedWeek={setSelectedWeek}
              />
            </div>
          </div>

          {isApiLoading || loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner style={{ width: "3rem", height: "3rem" }} />
            </div>
          ) : selectedWeeks ? (
            <>
              {/* Tabs */}
              <Nav tabs>
                <NavItem>
                  <NavLink
                    active={activeSubtab === "Topics Covered"}
                    onClick={() => toggleSubTab("Topics Covered")}
                    style={{ cursor: "pointer" }}
                  >
                    Topics Covered
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={activeSubtab === "Student Issues"}
                    onClick={() => toggleSubTab("Student Issues")}
                    style={{ cursor: "pointer" }}
                  >
                    Student Issues
                  </NavLink>
                </NavItem>
              </Nav>

              {/* Topics Covered */}
              {activeSubtab === "Topics Covered" && (
                <TableTopicsData
                  noRowsLabel="No Call Insights Available for this Week"
                  topicsData={tableDisplayData}
                  onTopicClick={handleTopicClick}
                  columns={[
                    { field: "sno", headerName: "S.No", width: 80, align: "center" },
                    { field: "topicName", headerName: "Topics", flex: 1 },
                    {
                      field: "Noofstudentsasked",
                      headerName: "No of Students Asked",
                      width: 230,
                      align: "center",
                    },
                    {
                      field: "Noofquestionsasked",
                      headerName: "No of Questions Asked",
                      width: 230,
                      align: "center",
                    },
                  ]}
                />
              )}

              {/* Student Issues (your snippet) */}
              {activeSubtab === "Student Issues" && (
                <div className="row mt-2">
                  <div className="col-md-12">
                    {tableissuesDisplayData &&
                    Object.keys(tableissuesDisplayData).length > 0 ? (
                      Object.keys(tableissuesDisplayData).map((category, categoryIndex) => {
                        const categoryData = tableissuesDisplayData[category];
                        const formatTitle = (str) =>
                          str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

                        return (
                          <div key={categoryIndex} className="mb-3">
                            {/* Category Title */}
                            <h4 className="fw-bold mb-2">{formatTitle(category)}</h4>

                            {/* <h4 className="fw-bold mb-1">
                              Students Flagged Based on 1:1 Session Engagement
                            </h4>
                            <p className="text-muted mb-3 mt-0 pt-0">
                              This list is generated based on students who have had at least one
                              1:1 consultation session with their facilitator during the previous
                              week.
                            </p>
                            <StudentIssueTable StudentList={studentIssueProactive} /> */}

                            {/* Topics inside this category */}

                            <div className="mb-3">
                                <span
                                  className="text-uppercase text-muted fw-bold tracking-wider small d-block mb-1"
                                  style={{ letterSpacing: "0.05em", fontSize: "0.75rem" }}
                                >
                                  Summary
                                </span>

                                <p className="mb-3 lh-base">
                                  {studentIssueSummary[category] || "No Summary available"}
                                </p>
                              </div>
                            {Object.keys(categoryData).map((topic, topicIndex) => (
                              <div
                                key={topicIndex}
                                className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light"
                              >
                                {/* Topic Title */}
                                <h6 className="fw-bold mb-2">{topic}</h6>

                                {/* Issues list */}
                                <ul className="ps-3">
                                  {categoryData[topic].map((issue, issueIndex) => (
                                    <li key={issueIndex} className="mb-1 text-dark">
                                      {issue}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        );
                      })
                    ) : (
                      <p className="ms-3">No Student Issues Available</p>
                    )}


                    <div className="col-md-12">
                    <h4 className="fw-bold mb-1">
                      Students Flagged Based on 1:1 Session Engagement
                    </h4>
                    <p className="text-muted mb-3 mt-0 pt-0">
                      This list is generated based on students who have had at least one
                      1:1 consultation session with their facilitator during the previous
                      week.
                    </p>
                    <StudentIssueTable StudentList={studentIssueProactive}  onStudentClick={onStudentClick}/>
                  </div>
                </div>

               
                </div>
              )}
            </>
          ) : (
            <p className="text-muted text-center mt-3">
              Please Select the week to view Call Insights
            </p>
          )}
        </CardBody>
      </Card>

      {/* ================= SECOND CARD ================= */}
      {/* <Card className="mb-2">
        <CardBody>
          <h5 className="fw-bold mb-2">AI Summary of All Topics</h5>

          {weekPeriod ? (
            <div
              className="va-summary-main"
              // Backend HTML. Consider sanitizing with DOMPurify before rendering.
              dangerouslySetInnerHTML={{
                __html: summaryAllTopics || "No Summary Available.",
              }}
            />
          ) : (
            <p className="text-muted text-center mb-0">
              Please Select the week to view AI Summary
            </p>
          )}
        </CardBody>
      </Card> */}

      {/* Modal */}
      <TopicDetailsModal
        open={openModal}
        onClose={handleCloseModal}
        title={modalTitle}
        contentDetails={modalContent?.clusters}
      />
    </div>
  );
};

export default TopicDiscussedTab;
